import { render } from "./ImgBlock.vue?vue&type=template&id=435d115a"
import script from "./ImgBlock.vue?vue&type=script&lang=js"
export * from "./ImgBlock.vue?vue&type=script&lang=js"

import "./ImgBlock.vue?vue&type=style&index=0&id=435d115a&lang=css"

import exportComponent from "/home/claude/weedborncounty/weedborncounty/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__